import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  position: relative;
  min-width: 100vw;
  min-height: 60vh;
`;

const Header = () => {
  return (
    <StyledDiv className="flex flex-col justify-start items-center pt-14 md:justify-center">
      <div className="px-10 w-full h-full flex flex-col py-20 md:px-20 md:mb-40  lg:px-30 lg:w-11/12">
        <h1 className="font-rubik font-bold text-4xl overflow-hidden lg:text-5xl lg:w-4/5 lg:pt-5">
          Hello there, <br />
          I'm Prins Ocampo.
        </h1>
        <p className="font-karla font-normal text-lg mt-4 md:text-xl text-gray-700  md:w-10/12 lg:w-5/12 2xl:w-2/5">
          I'm an aspiring{" "}
          <span className="text-black font-bold">web developer</span> that is
          passionate about creating fully{" "}
          <span className="text-black font-bold">responsive</span> and
          functional web applications.
        </p>
        <p className="font-karla font-normal text-lg mt-4 md:text-xl text-gray-700  md:w-10/12 lg:w-5/12 2xl:w-2/5">
          I'm currently{" "}
          <span className="text-black font-bold">looking for a job</span> as an
          entry-level or junior position in web development. If your company has
          any job opening please feel free to contact me. Thank you!
        </p>
        <a
          href="Prins_CV.pdf"
          target="_blank"
          className="font-karla font-medium hover:--tw-scale-y: 1; transition duration-200 ease-in-out outline-none focus:outline-none text-white py-2 px-4 w-36 rounded-lg mt-5 shadow-lg bg-gradient-to-r from-indigo-400 to-blue-400  hover:from-white border border-transparent hover:to-white hover:border-blue-400 hover:text-blue-600 md:text-lg"
        >
          Download CV
        </a>
      </div>
      <img
        alt="programming"
        className="px-10 pt-5 pb-20 md:absolute md:w-4/6 md:bottom-0 md:right-8 md:pb-5 lg:w-3/6 lg:right-2 lg:bottom-10"
        src="./images/svg/programming.svg"
      ></img>
    </StyledDiv>
  );
};

export default Header;
